/* tslint:disable */



      export interface IntrospectionResultData {
        __schema: {
          types: {
            kind: string;
            name: string;
            possibleTypes: {
              name: string;
            }[];
          }[];
        };
      }
      const result: IntrospectionResultData = {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "ISettingsSubject",
        "possibleTypes": [
          {
            "name": "DefaultSettings"
          },
          {
            "name": "UserSettings"
          },
          {
            "name": "LocalUserSettings"
          },
          {
            "name": "RemoteUserSettings"
          },
          {
            "name": "FolderSettings"
          },
          {
            "name": "GlobalSettings"
          },
          {
            "name": "WorkspaceSettings"
          },
          {
            "name": "MemorySettings"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SettingsSubject",
        "possibleTypes": [
          {
            "name": "UserSettings"
          },
          {
            "name": "LocalUserSettings"
          },
          {
            "name": "RemoteUserSettings"
          },
          {
            "name": "FolderSettings"
          },
          {
            "name": "GlobalSettings"
          },
          {
            "name": "WorkspaceSettings"
          },
          {
            "name": "MemorySettings"
          },
          {
            "name": "DefaultSettings"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IStatusbarItem",
        "possibleTypes": [
          {
            "name": "Terminal"
          },
          {
            "name": "SelectionStatus"
          },
          {
            "name": "Indentation"
          },
          {
            "name": "EncodingStatus"
          },
          {
            "name": "EndOfLineSequence"
          },
          {
            "name": "LanguageMode"
          },
          {
            "name": "SyncStatus"
          },
          {
            "name": "BranchStatus"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "EditorChildren",
        "possibleTypes": [
          {
            "name": "EditorPart"
          },
          {
            "name": "EditorGroup"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IEditorGroup",
        "possibleTypes": [
          {
            "name": "EditorGroup"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "EditorInput",
        "possibleTypes": [
          {
            "name": "DataUriEditorInput"
          },
          {
            "name": "DiffEditorInput"
          },
          {
            "name": "FileEditorInput"
          },
          {
            "name": "KeybindingEditorInput"
          },
          {
            "name": "PreferencesEditorInput"
          },
          {
            "name": "ResourceEditorInput"
          },
          {
            "name": "SideBySideEditorInput"
          },
          {
            "name": "UntitledEditorInput"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IEditorInput",
        "possibleTypes": [
          {
            "name": "DataUriEditorInput"
          },
          {
            "name": "DiffEditorInput"
          },
          {
            "name": "FileEditorInput"
          },
          {
            "name": "KeybindingEditorInput"
          },
          {
            "name": "PreferencesEditorInput"
          },
          {
            "name": "ResourceEditorInput"
          },
          {
            "name": "SideBySideEditorInput"
          },
          {
            "name": "UntitledEditorInput"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IBaseStat",
        "possibleTypes": [
          {
            "name": "FileStatWithMetadata"
          },
          {
            "name": "TextFileStreamContent"
          },
          {
            "name": "TextFilePublishContent"
          },
          {
            "name": "TextFileContent"
          },
          {
            "name": "FileContent"
          },
          {
            "name": "FileStat"
          },
          {
            "name": "FileStreamContent"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IBaseStatWithMetadata",
        "possibleTypes": [
          {
            "name": "FileStatWithMetadata"
          },
          {
            "name": "TextFileStreamContent"
          },
          {
            "name": "TextFileContent"
          },
          {
            "name": "FileContent"
          },
          {
            "name": "FileStreamContent"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IContentChangedEvent",
        "possibleTypes": [
          {
            "name": "FileStatWithMetadata"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IFileClientMetadata",
        "possibleTypes": [
          {
            "name": "FileStatWithMetadata"
          },
          {
            "name": "TextFileContent"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ITreeItem",
        "possibleTypes": [
          {
            "name": "FileStatWithMetadata"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IUntitledFileValue",
        "possibleTypes": [
          {
            "name": "FileStatWithMetadata"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IEditorInputWithGroupFields",
        "possibleTypes": [
          {
            "name": "DataUriEditorInput"
          },
          {
            "name": "DiffEditorInput"
          },
          {
            "name": "FileEditorInput"
          },
          {
            "name": "KeybindingEditorInput"
          },
          {
            "name": "PreferencesEditorInput"
          },
          {
            "name": "ResourceEditorInput"
          },
          {
            "name": "SideBySideEditorInput"
          },
          {
            "name": "UntitledEditorInput"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IFileEditorInput",
        "possibleTypes": [
          {
            "name": "FileEditorInput"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IEncodingSupport",
        "possibleTypes": [
          {
            "name": "FileEditorInput"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IModeSupport",
        "possibleTypes": [
          {
            "name": "FileEditorInput"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ISideBySideEditorInput",
        "possibleTypes": [
          {
            "name": "PreferencesEditorInput"
          },
          {
            "name": "SideBySideEditorInput"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Node",
        "possibleTypes": [
          {
            "name": "RegistryExtension"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ISearchCompleteStats",
        "possibleTypes": [
          {
            "name": "SearchComplete"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "SearchCompleteStatsStats",
        "possibleTypes": [
          {
            "name": "FileSearchStats"
          },
          {
            "name": "TextSearchStats"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "FileSearchStatsdetailStats",
        "possibleTypes": [
          {
            "name": "SearchEngineStats"
          },
          {
            "name": "CachedSearchStats"
          },
          {
            "name": "FileSearchProviderStats"
          },
          {
            "name": "FileIndexProviderStats"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IFileMatch",
        "possibleTypes": [
          {
            "name": "FileMatch"
          },
          {
            "name": "SearchProgressItem"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "TextSearchResult",
        "possibleTypes": [
          {
            "name": "TextSearchMatch"
          },
          {
            "name": "TextSearchContext"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IDebugParams",
        "possibleTypes": [
          {
            "name": "ExtensionHostDebugParams"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IViewDescriptor",
        "possibleTypes": [
          {
            "name": "ViewDescriptor"
          },
          {
            "name": "TreeViewDescriptor"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IStaticWorkspaceData",
        "possibleTypes": [
          {
            "name": "WorkspaceData"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IBaseTextFileContent",
        "possibleTypes": [
          {
            "name": "TextFileStreamContent"
          },
          {
            "name": "TextFilePublishContent"
          },
          {
            "name": "TextFileContent"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "StatusbarItem",
        "possibleTypes": [
          {
            "name": "Terminal"
          },
          {
            "name": "SelectionStatus"
          },
          {
            "name": "Indentation"
          },
          {
            "name": "EncodingStatus"
          },
          {
            "name": "EndOfLineSequence"
          },
          {
            "name": "LanguageMode"
          },
          {
            "name": "SyncStatus"
          },
          {
            "name": "BranchStatus"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ITextDocumentIdentifier",
        "possibleTypes": [
          {
            "name": "TextDocumentIdentifier"
          },
          {
            "name": "TextDocumentItem"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "TextDocumentPositionParams",
        "possibleTypes": [
          {
            "name": "ProvideTextDocumentLocationSignature"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "Location",
        "possibleTypes": [
          {
            "name": "ProvideTextDocumentLocationSignature"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "URIToOpen",
        "possibleTypes": [
          {
            "name": "WorkspaceToOpen"
          },
          {
            "name": "FolderToOpen"
          },
          {
            "name": "FileToOpen"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IPathData",
        "possibleTypes": [
          {
            "name": "Path"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "IPathsToWaitForData",
        "possibleTypes": [
          {
            "name": "PathsToWaitFor"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "ISearchProgress",
        "possibleTypes": [
          {
            "name": "SearchProgressItem"
          }
        ]
      }
    ]
  }
};
      export default result;
    